import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap'
import { useState, useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import API from '../api/api'
import Actions from '../redux/actions'
import { MdPhoneIphone, MdTextsms } from 'react-icons/md'
import PhoneInput from 'react-phone-number-input'

export default function AddNotifyNum(props) {

    const [number, setNumber] = useState('')
    const [loading, setLoading] = useState(false)
    const [err, setErr] = useState('')

    const user = useSelector(state => state.user)
    const selectedUser = useSelector(state => state.selectedUser)
    const dispatch = useDispatch()

    useEffect(() => {

    }, [])


    const addNumber = async (e) => {
        e.preventDefault()
        if (selectedUser.notifyNumbers.length === 3) {
            dispatch(Actions.setToast('🚨 Max Numbers Added 🚨', 'You can only add 3 numbers per account'))
            return
        }
        const found = selectedUser?.notifyNumbers?.find(num => num === number)
        if (found) {
            dispatch(Actions.setToast('🚨 This number is already added 🚨', 'You cannot add the same number twice'))
            return
        }

        if (number === user.phone) {
            dispatch(Actions.setToast('🚨 You cannot add your number 🚨', 'Your number is notified by default'))
            return
        }
        setLoading(true)
        const updatedUser = await API.addNotifyNumber(selectedUser._id, number)
        dispatch(Actions.updateAccount(updatedUser))
        setLoading(false)
        dispatch(Actions.setToast(`${number} added to ${selectedUser?.fName} ${selectedUser?.lName}`, 'They will now receive text updates'))
        props.close()
    }


    return (
        <Container>
            <Form className='mt-1 mb-4 px-4' onSubmit={addNumber}>
                <p className='text-center'><MdPhoneIphone className='text-primary' size='8rem' /></p>
                <p className='text-center'><b className='weight-bold text-primary'>User: </b> {selectedUser?.fName} {selectedUser?.lName}</p>
                <p className='text-center'>Add a number to get a text notification when this user is potentially falling victim to a scam.</p>

                <PhoneInput
                    placeholder="Enter phone number"
                    value={number}
                    defaultCountry="US"
                    onChange={setNumber}
                    inputClass='form-control'
                />

                {loading && <div className='text-center my-2'><Spinner animation='border'></Spinner></div>}
                {err !== '' && <Alert variant='danger'>Error: {err}</Alert>}
                <div className='text-center mt-4'>
                    <Button type='submit' disabled={loading || number?.length !== 12}>Add Number</Button>
                </div>

            </Form>
        </Container>
    )
}